var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.97 87.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #039;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: #e0e8f6;\n      }\n\n      .cls-5 {\n        fill: #204cba;\n        mix-blend-mode: multiply;\n        opacity: .2;\n      }\n\n      .cls-6 {\n        fill: #3a4561;\n      }\n\n      .cls-7 {\n        fill: #00cc87;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.37.54h38.94c2.58,0,4.67,2.09,4.67,4.67v76.67c0,2.58-2.09,4.67-4.67,4.67H20.37c-2.58,0-4.67-2.09-4.67-4.67V5.21c0-2.58,2.09-4.67,4.67-4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.46,87.1H20.22c-2.79,0-5.06-2.41-5.06-5.37v-19.41c0-.3.24-.54.54-.54s.54.24.54.54v19.41c0,2.36,1.79,4.29,3.98,4.29h39.24c2.2,0,3.98-1.92,3.98-4.29V5.37c0-2.36-1.79-4.29-3.98-4.29H20.22c-2.2,0-3.98,1.92-3.98,4.29v19.41c0,.3-.24.54-.54.54s-.54-.24-.54-.54V5.37c0-2.96,2.27-5.37,5.06-5.37h39.24c2.79,0,5.06,2.41,5.06,5.37v76.36c0,2.96-2.27,5.37-5.06,5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.8,15.37V5.65c0-.51-.42-.92-.92-.92H20.8c-.51,0-.92.41-.92.92v9.73h39.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47.82,5.12h-15.96c-.3,0-.54-.24-.54-.54s.24-.54.54-.54h15.96c.3,0,.54.24.54.54s-.24.54-.54.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 41.37,
    y: 21.77,
    width: 6.86,
    height: 43.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.93,46.24c0,8.67-7.03,15.69-15.69,15.69-.18,0-.36,0-.55-.01v-31.37c.18,0,.36-.01.55-.01,8.67,0,15.69,7.03,15.69,15.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.69,
    cy: 43.55,
    r: 15.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.75 50.7 7.2 45.14 9.11 43.23 12.75 46.88 22.28 37.35 24.19 39.26 12.75 50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.43,28.09v30.93c0,.89-.73,1.62-1.62,1.62h-40.01V26.47h40.01c.89,0,1.62.73,1.62,1.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 44.8,
    y: 32.74,
    width: 41.63,
    height: 6.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.81,61.17h-40.01c-.3,0-.54-.24-.54-.54s.24-.54.54-.54h40.01c.6,0,1.08-.48,1.08-1.08v-30.93c0-.6-.48-1.08-1.08-1.08h-40.01c-.3,0-.54-.24-.54-.54s.24-.54.54-.54h40.01c1.19,0,2.16.97,2.16,2.16v30.93c0,1.19-.97,2.16-2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 72.77,
    y: 46.67,
    width: 6.75,
    height: 6.75,
    transform: "translate(-13.08 68.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 44.8,
    y: 46.24,
    width: 13.74,
    height: 1.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 44.8,
    y: 51.91,
    width: 23.7,
    height: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.88,80.04l39.92-10.85v12.25c0,.51-.41.92-.92.92H20.8c-.51,0-.92-.41-.92-.92v-1.41Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.1046f986c93f843de1a528b8b4595f18.svg";
export { ForwardRef as ReactComponent };